export default __webpack_public_path__ + "assets/images/fe1a574366215848bc13fd83348da5ba.jpg";